import { schema } from "normalizr";
import { Transaction } from "./transaction";

export const Transactions = new schema.Array(Transaction);
